export const ROTATION_HANDLE_OFFSET = 42;

export const getPointerAngle = (clientX, clientY, center) => {
    return Math.atan2(clientY - center.y, clientX - center.x) * 180 / Math.PI;
};

const getSelectionElement = (id, json) => {
    if (json?.[id]?.type === 'text') return document.getElementById(`text-${id}`);
    return document.getElementById(`caixa-${id}`) || document.getElementById(`text-${id}`);
};

export const getSelectionClientMetrics = (json, selectedIds) => {
    const rects = (selectedIds || [])
        .map(id => ({
            id,
            element: getSelectionElement(id, json)
        }))
        .filter(({ element }) => Boolean(element))
        .map(({ id, element }) => ({
            id,
            rect: element.getBoundingClientRect()
        }))
        .filter(({ rect }) => rect.width > 0 || rect.height > 0);

    if (rects.length === 0) return null;

    const bounds = rects.reduce((acc, { rect }) => ({
        left: Math.min(acc.left, rect.left),
        top: Math.min(acc.top, rect.top),
        right: Math.max(acc.right, rect.right),
        bottom: Math.max(acc.bottom, rect.bottom)
    }), {
        left: Infinity,
        top: Infinity,
        right: -Infinity,
        bottom: -Infinity
    });

    const center = rects.reduce((acc, { rect }) => ({
        x: acc.x + (rect.left + rect.width / 2) / rects.length,
        y: acc.y + (rect.top + rect.height / 2) / rects.length
    }), { x: 0, y: 0 });

    return {
        ids: rects.map(({ id }) => id),
        center,
        rect: {
            ...bounds,
            width: bounds.right - bounds.left,
            height: bounds.bottom - bounds.top
        }
    };
};

export const getRotationHandlePosition = (metrics) => {
    if (!metrics) return null;

    return {
        x: metrics.rect.left + metrics.rect.width / 2,
        y: metrics.rect.top - ROTATION_HANDLE_OFFSET
    };
};
